export const PARTNER_DATA_SUCCESS = 'PARTNER/DATA_SUCCESS'
export const PARTNER_DATA_FAILURE = 'PARTNER/DATA_FAILURE'